import Vendor from '../vendor.config';

export const CHAKRA_MAX_WIDTH_MOBILE = `(max-width: 1167px)`;
export const CONTENT_MAX_WIDTH = `1240px`;

export const scrollInvisible = {
	'&::-webkit-scrollbar': {
		display: 'none',
	},
	'&::-webkit-scrollbar-track': {
		display: 'none',
	},
	'&::-webkit-scrollbar-thumb': {
		display: 'none',
	},
};

export const scrollColoredSmall = (background: string, color: string) => ({
	'&::-webkit-scrollbar': {
		width: '5px',
		backgroundColor: background,
		borderRadius: '5px',
	},
	'&::-webkit-scrollbar-thumb': {
		borderRadius: '5px',
		backgroundColor: color,
	},
});

/**
 * Yields a hex colors
 * @param color hex string
 * @param percent 0-100; @dev gets converted to hex
 */
export const getTransparent = (color: string, percent: number) => {
	return `${color}${fromPercent_(percent)}`;
};

const fromPercent_ = (valNum: number) => {
	let decimalValue = Math.round((valNum * 255) / 100);

	if (valNum < 7) {
		return '0' + decimalValue.toString(16).toUpperCase();
	} else {
		return decimalValue.toString(16).toUpperCase();
	}
};

export const extractTheme = (color: string[] | string) => {
	if (typeof color === 'string') {
		return color;
	}

	return Vendor.gui.theme === 'light' ? color[0] : color[1];
};
